import { AttributeMappingType, type AttributeReferenceConfig } from 'pages/Financials/financials-widget-drawer/types';

export const shouldInsertFinancialMappingAxes = (
  isAttributeMapperEnabled: boolean,
  attributeReferenceConfig?: Pick<AttributeReferenceConfig, 'selectionMode'> | null
): boolean =>
  Boolean(
    isAttributeMapperEnabled &&
      attributeReferenceConfig &&
      attributeReferenceConfig.selectionMode !== AttributeMappingType.SINGLE_CELL
  );
